import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import tinycolor from 'tinycolor2'
import InitiativeJoinButton from 'src/apps/Initiative/components/JoinButton'
import InitiativeNav from 'src/apps/Initiative/components/Nav'
import InitiativeStatusBanner from 'src/apps/Initiative/components/StatusBanner'
import InitiativeTypeLabel from 'src/apps/Initiative/components/TypeLabel'
import Footer from 'src/components/Footer'
import { useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const InitiativeContainerLayout1 = ({ children }) => {
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)

   const coverURL = initiative.coverMedia?.file.thumbnailUrlW1600
   const headingTextColor = 'rgba(0,0,0,1)'

   const userIsAdmin = initiative.currentUserRelationship?.elements.find(element => (
      element.__typename === 'RelationshipElementRoleParticipant' &&
      element.role.type === 'admin' &&
      element.status === 'active'
   ))

   return (
      <>
         <Helmet title={`${initiative.name} | ${organization.name}`} />
         <View
            position="relative"
            width="100%"
            backgroundColor="#fff"
            paddingTop={theme.viewportMarginTop}
            paddingLeft={theme.viewportMarginLeft}
            paddingRight={theme.viewportMarginRight}>
            <InitiativeStatusBanner />
            <View display="flex" justifyContent="center" width="100%">
               <View width="100%" maxWidth={theme.viewportContentMaxWidth}>
                  <View
                     float="left"
                     paddingLeft={theme.viewportPaddingLeft}
                     paddingRight="18px[a] 9vw[b] 6vw[c] 4vw[d] 42px[e-f]"
                     width="100%[a-c] 46%[d] 46%[e-f]">
                     <View
                        float="left"
                        width="100%"
                        backgroundColor="#fff"
                        maxWidth="780px[c]"
                        paddingTop="70px">
                        <View
                           float="left"
                           display="flex"
                           alignItems="center"
                           flexFlow="column"
                           width="100%"
                           paddingHorizontal="25px[c-f]"
                           textAlign="center">
                           <InitiativeTypeLabel />
                           <View float="left" width="100%" height="6px[a-d] 12px[e-f]" />
                           <Text
                              color={headingTextColor}
                              size="8[a-b] 11[c] 9[d] 10[e] 10[f]"
                              letterSpacing="-0.5px"
                              weight="medium">
                              {initiative.name}
                           </Text>
                           {initiative.subtitle && (
                              <View float="left" width="100%" marginTop="18px[a-b] 24px[c-f]">
                                 <Text
                                    size="3[a-b] 4[c] 3[d] 4[e-f]"
                                    lineHeight="130%"
                                    color={tinycolor(headingTextColor).setAlpha(0.5)}>
                                    {initiative.subtitle}
                                 </Text>
                              </View>
                           )}
                           <View
                              display="block"
                              float="left"
                              width="100%"
                              marginTop="18px[a-b] 30px[c-f]"
                              marginBottom="18px[a-b] 30px[c-f]"
                              borderTop={`1px solid ${tinycolor(headingTextColor).setAlpha(0.1)}`}
                           />
                           {initiative.joinable && (
                              <View
                                 display="flex"
                                 justifyContent="center"
                                 float="left"
                                 width="100%">
                                 <InitiativeJoinButton />
                              </View>
                           )}
                           {userIsAdmin && (
                              <View
                                 float="left"
                                 width="100%"
                                 paddingTop="18px"
                                 textAlign="center">
                                 <Text size="2" color="#666">
                                    {`You are an Admin of this ${initiative.type.nameSingular}`}
                                 </Text>
                              </View>
                           )}
                        </View>
                        {coverURL && (
                           <View
                              float="left"
                              width="100%"
                              marginTop="18px[a] 24px[b] 36px[c] 30px[d] 36px[e-f]"
                              marginBottom="60px[d-f]">
                              <img
                                 src={coverURL}
                                 alt={initiative.name}
                                 width="100%"
                              />
                           </View>
                        )}
                     </View>
                  </View>
                  <View
                     float="left"
                     display="flex"
                     justifyContent="center"
                     paddingRight={theme.viewportPaddingRight}
                     width="100%[a-c] 54%[d] 54%[e-f]"
                     minHeight="100vh"
                     borderLeft="1px solid #eee[d-f]">
                     <View
                        width="100%"
                        backgroundColor="#fff"
                        maxWidth="780px[c]"
                        paddingLeft="18px[a] 9vw[b] 6vw[c] 4vw[d] 42px[e-f]">
                        <View
                           float="left"
                           width="100%"
                           paddingTop="25px"
                           borderBottom="1px solid #eee">
                           <InitiativeNav />
                        </View>
                        <View
                           float="left"
                           width="100%"
                           paddingBottom="90px">
                           {children}
                        </View>
                     </View>
                  </View>
               </View>
            </View>
            <Footer backgroundColor="#111" />
         </View>
      </>
   )
}

InitiativeContainerLayout1.propTypes = {
   children: PropTypes.node.isRequired
}

export default InitiativeContainerLayout1
